import { MailLink } from "features/Common/modules/MailLink/MailLink";
import React from "react";
import { useRequestVerificationKRAModal } from "../modules/utils/useRequestVerificationKRAModal";
import { ExlyImage } from "@my-scoot/exly-react-component-lib";
import { getOptimisedS3AssetCDNUrl } from "features/Common/modules/File/modules/Upload/utils/FileUpload.utils";
import { REQUEST_KRA_CONTENT_CONSTANTS } from "../constants/RequestVerificationKRA.constants";

export const AccessRequestedTitle = ({ config }) => {
  const {
    openRequestVerificationSubmitFormModal,
    areCVLLoginCredSubmitted,
    requestVerificationConfig,
  } = useRequestVerificationKRAModal(config);

  const { text = {} } = requestVerificationConfig;

  return (
    <div>
      We&apos;ll notify you once your KRA verification is complete. In the
      meantime, please complete the following steps:
      <ol className="tw-pl-4 tw-mt-[8px]" style={{ color: text.color }}>
        <li className="tw-mb-[8px]">
          <strong>Create an Admin account on CVL:</strong>
          <br />
          If you don&apos;t already have an Admin account for KRA on CVL/NDML,
          please create one on
          <span className="tw-ml-1">
            <a
              href={REQUEST_KRA_CONTENT_CONSTANTS.CVL_WEBSITE}
              className="tw-text-[#493ab1] tw-underline tw-font-semibold"
              target="_blank"
              rel="noreferrer"
            >
              {REQUEST_KRA_CONTENT_CONSTANTS.CVL_WEBSITE}
            </a>
          </span>
          <span className="tw-mx-1">/</span>
          <span>
            <a
              href={REQUEST_KRA_CONTENT_CONSTANTS.NDML_WEBSITE}
              className="tw-text-[#493ab1] tw-underline tw-font-semibold"
              target="_blank"
              rel="noreferrer"
            >
              {REQUEST_KRA_CONTENT_CONSTANTS.NDML_WEBSITE}
            </a>
          </span>
        </li>

        <li className="tw-mb-[8px]">
          <strong>Enable API access:</strong>
          <br />
          Send an email to
          <span className="tw-mx-1">
            <MailLink
              linkText={REQUEST_KRA_CONTENT_CONSTANTS.CVL_INDIA_EMAIL}
              emailId={REQUEST_KRA_CONTENT_CONSTANTS.CVL_INDIA_EMAIL}
            />
          </span>
          requesting API access and SFTP details.
          <br />
          Also, ask them to whitelist the following IP addresses:
          <br />· {REQUEST_KRA_CONTENT_CONSTANTS.EXLY_BACKEND_IPS[0]}
          <br />· {REQUEST_KRA_CONTENT_CONSTANTS.EXLY_BACKEND_IPS[1]}
        </li>

        <li>
          <strong>Create a Web User and share credentials:</strong>
          <br />
          Once your Admin account is ready, create a new user with terminal type{" "}
          <strong>WEBUSER</strong> on CVL.
          <br />
          Share the login ID and password with us so we can complete the
          integration below.
          <div
            className={`tw-p-2 tw-border-[#473904] tw-flex tw-justify-center tw-items-center tw-mt-2 tw-w-fit tw-font-semibold tw-border-solid tw-border-2 tw-rounded-md tw-cursor-pointer ${
              areCVLLoginCredSubmitted
                ? "tw-pointer-events-none tw-cursor-not-allowed tw-p-0 tw-border-none -tw-ml-2"
                : ""
            }`}
            onClick={openRequestVerificationSubmitFormModal}
          >
            {areCVLLoginCredSubmitted ? (
              <>
                <ExlyImage
                  className="tw-size-5"
                  src={getOptimisedS3AssetCDNUrl("Account/in_progress.png")}
                />
                <span className="tw-ml-2">
                  We are reviewing your Submitted Credentials...
                </span>
              </>
            ) : (
              "Submit CVL Credentials"
            )}
          </div>
        </li>
      </ol>
    </div>
  );
};
